import './ColumnGroupToggle.scss';
import { RefObject } from 'react';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';

interface ColumnGroupToggleButtonProps {
  /** Whether the column group is visible */
  visible: boolean;
  /** Toggle handler */
  onToggle: () => void;
  /** Ref for positioning the bracket */
  buttonRef: RefObject<HTMLButtonElement | null>;
  /** Width of the bracket line (0 = no bracket) */
  bracketWidth: number;
  /** Tooltip text when visible */
  hideTooltip?: string;
  /** Tooltip text when hidden */
  showTooltip?: string;
}

/** Toggle button with SVG bracket line extending to the last column in the group */
// Plain button, not IconButton: the bracket geometry needs these exact compact dimensions
export const ColumnGroupToggleButton = ({
  visible,
  onToggle,
  buttonRef,
  bracketWidth,
  hideTooltip = 'Hide columns',
  showTooltip = 'Show columns'
}: ColumnGroupToggleButtonProps) => (
  <div className='column-group-toggle-wrapper'>
    <button
      type='button'
      ref={buttonRef}
      className='column-group-toggle-btn'
      onClick={onToggle}
      title={visible ? hideTooltip : showTooltip}
    >
      {visible ? <MdVisibilityOff /> : <MdVisibility />}
    </button>
    {visible && bracketWidth > 0 && (
      <svg
        className='column-group-bracket-svg'
        width={bracketWidth}
        height='1'
        preserveAspectRatio='none'
      >
        <line x1='0' y1='0.5' x2={bracketWidth} y2='0.5' stroke='currentColor' strokeWidth='1' />
      </svg>
    )}
  </div>
);

interface ColumnGroupBracketEndProps {
  /** Ref for positioning (bracket ends here) */
  endRef: RefObject<HTMLDivElement | null>;
  /** Whether to show the bracket end marker */
  visible: boolean;
}

/** Bracket end marker - place in the last column header of the group */
export const ColumnGroupBracketEnd = ({ endRef, visible }: ColumnGroupBracketEndProps) => {
  if (!visible) {
    return null;
  }
  return <div ref={endRef} className='column-group-bracket-drop' />;
};
